import { render } from "./EbookTab.vue?vue&type=template&id=0d93fbd2&scoped=true"
import script from "./EbookTab.vue?vue&type=script&lang=js"
export * from "./EbookTab.vue?vue&type=script&lang=js"

import "./EbookTab.vue?vue&type=style&index=0&id=0d93fbd2&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d93fbd2"]])

export default __exports__